import {injectable} from "inversify";
import {Country, Region} from "@/modules/base/entity";
import chance from "@/modules/base/services/chance";

@injectable()
export default class CountryRandomizer {
  private countries: Country[];

  public async one(region?: Region) {
    if (!this.countries) {
      this.countries = await Country
        .createQueryBuilder('country')
        .innerJoinAndSelect('country.region', 'region')
        .getMany();
    }

    let countries = this.countries;

    if (region) {
      countries = countries.filter(c => c.region.equals(region));
    }

    return chance.pickoneByFieldProbability(
      countries,
      (c: Country) => Math.max(1, Math.round(Math.min(50 * 10 ** 6, c.population) * c.level))
    );
  }
}
